import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import type { Dayjs } from 'dayjs'
import dayjsConfig from '@store/timetable/dayjs.config'
import timeZonesEnam from '@/constant/timeZonesEnam'

dayjsConfig.extend(utc)
dayjsConfig.extend(timezone)

export const PLATFORM_WALL_CLOCK_FORMAT = 'YYYY-MM-DD HH:mm:ss'

/**
 * «Сейчас» в часовом поясе платформы как naive datetime для DatePicker
 * (без сдвига browser TZ при выборе в CRM-полях).
 */
export const getPlatformWallClockNow = (
  timeZone: string = timeZonesEnam.GMT_MINUS_3,
): Dayjs => {
  const zone = timeZone || timeZonesEnam.GMT_MINUS_3
  const wallClock = dayjsConfig().tz(zone).format(PLATFORM_WALL_CLOCK_FORMAT)
  return dayjsConfig(wallClock, PLATFORM_WALL_CLOCK_FORMAT)
}
